
  document.addEventListener('DOMContentLoaded', function () {
    $('.accordion-toggle').on('click', function () {
      const $toggle = $(this);
      const $content = $toggle.next('.accordion-content');
      const $item = $toggle.parent('.accordion-item');

      if ($item.hasClass('active')) {
        $content.slideUp(300);
        $item.removeClass('active');
      } else {
        $content.slideDown(300);
        $item.addClass('active');
      }
    });
  });
 
  $('.glry-slidr').owlCarousel({
      loop: true,
      margin: 30,
      dots: false,
      nav: true,
      items: 5,
      autoplay: false,
      responsive: {
          0: {
              items: 1
          },
          480: {
              items: 2
          },
          768: {
              items: 3
          },
          1024: {
              items: 4
          },
          1200: {
              items: 5
          }
      }
  })